var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"commentInputer"},[_c('input',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('button',{on:{"click":_vm.send}},[_vm._v("发送")])])
}
var staticRenderFns = []

export { render, staticRenderFns }